import crud_actions from './crud_actions'

export const loadUserProfile = crud_actions.read('user', 'loadUserByUsername')

export const findInterestingPeople = crud_actions.read(
  'users',
  'findInterestingPeople'
)
